module.exports = __webpack_public_path__ + "img/sousuo-gif.gif";